import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import ThemeToggle from './ThemeToggle';
import SnakeGame from './SnakeGame';
import './LockdownPage.css';

function LockdownPage() {
    const { darkMode } = useTheme();
    const [dotCount, setDotCount] = useState(0);
    const [lastClickTime, setLastClickTime] = useState(0);
    const [showGame, setShowGame] = useState(false);

    const handleDotClick = () => {
        const now = Date.now();
        if (now - lastClickTime > 2000) {
            setDotCount(1);
        } else {
            setDotCount(prev => {
                if (prev === 2) {
                    setShowGame(true);
                    return 0;
                }
                return prev + 1;
            });
        }
        setLastClickTime(now);
    };

    return (
        <div className={`lockdown-page ${darkMode ? 'dark' : 'light'}`}>
            <div className="theme-toggle-wrapper">
                <ThemeToggle />
            </div>
            <div className="lockdown-content">
                <h1>Lukas Schulte</h1>
                <p className="subtitle">Software Engineer</p>
                <div className="message">
                    <p>Thank you for your interest!</p>
                    <p>For inquiries, please contact me at:</p>
                    <a 
                        href="mailto:contact@lukasschulte.com" 
                        className="contact-link"
                        aria-label="Send email to contact@lukasschulte.com"
                    >
                        contact@lukasschulte.com
                    </a>
                </div>
                <div 
                    className={`fun-element`}
                    onClick={handleDotClick}
                    role="button"
                    aria-label="Click to reveal a surprise"
                >
                    <div className="quantum-bit">
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="wave"></div>
                        <div className="qubit-circle"></div>
                    </div>
                    <div className="measurement-text">
                        {dotCount > 0 && (
                            <p className="measurement-hint">
                                {dotCount === 1 ? "Something's happening..." : "Almost there..."}
                            </p>
                        )}
                    </div>
                    <p className="fun-hint">
                        {".".repeat(dotCount)}
                    </p>
                </div>
            </div>
            {showGame && (
                <SnakeGame 
                    onClose={() => setShowGame(false)}
                    darkMode={darkMode}
                />
            )}
        </div>
    );
}

export default LockdownPage; 